import {TablePagination as MUITablePagination} from '@mui/material'

export const TablePagination = MUITablePagination
